type ProductKey = 'cases' | 'chargers' | 'cables' | 'glass' | 'audio' | 'powerbanks'

export function ProductIllustration({ type }: { type: ProductKey }) {
  const common = { fill: 'none', stroke: 'currentColor', strokeWidth: 2.2, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const }

  if (type === 'cases') {
    return (
      <svg viewBox="0 0 480 480" aria-hidden="true">
        <rect x="132" y="64" width="216" height="352" rx="42" {...common} />
        <rect x="151" y="83" width="178" height="314" rx="28" {...common} opacity="0.35" />
        <circle cx="190" cy="132" r="20" {...common} />
        <circle cx="241" cy="132" r="20" {...common} />
        <circle cx="190" cy="183" r="20" {...common} />
        <path d="M284 326c-22 22-66 24-92 0" {...common} opacity="0.5" />
      </svg>
    )
  }

  if (type === 'chargers') {
    return (
      <svg viewBox="0 0 480 480" aria-hidden="true">
        <rect x="136" y="116" width="208" height="226" rx="34" {...common} />
        <path d="M190 116V72M290 116V72" {...common} />
        <path d="M216 221h48M240 197v48" {...common} opacity="0.45" />
        <path d="M176 342v66M304 342v66" {...common} opacity="0.55" />
      </svg>
    )
  }

  if (type === 'cables') {
    return (
      <svg viewBox="0 0 480 480" aria-hidden="true">
        <path d="M106 116c0 0 106-43 184 25 77 67 49 179-28 216-58 28-125 9-137-42-13-53 49-82 93-56 38 23 21 74-18 75" {...common} />
        <rect x="84" y="88" width="58" height="70" rx="12" {...common} />
        <path d="M100 88V58M126 88V58" {...common} />
        <rect x="180" y="312" width="61" height="83" rx="13" {...common} />
        <path d="M199 395v29M222 395v29" {...common} />
      </svg>
    )
  }

  if (type === 'glass') {
    return (
      <svg viewBox="0 0 480 480" aria-hidden="true">
        <rect x="111" y="58" width="230" height="362" rx="38" {...common} />
        <rect x="146" y="82" width="230" height="362" rx="38" {...common} opacity="0.42" />
        <path d="M187 109h80" {...common} opacity="0.5" />
        <path d="M160 356l172-199" {...common} opacity="0.25" />
        <path d="M179 388l172-199" {...common} opacity="0.25" />
      </svg>
    )
  }

  if (type === 'audio') {
    return (
      <svg viewBox="0 0 480 480" aria-hidden="true">
        <path d="M162 94c-50 25-72 75-64 126 5 35 27 66 56 83" {...common} />
        <path d="M318 94c50 25 72 75 64 126-5 35-27 66-56 83" {...common} />
        <rect x="126" y="265" width="72" height="126" rx="34" {...common} />
        <rect x="282" y="265" width="72" height="126" rx="34" {...common} />
        <path d="M162 391v32M318 391v32" {...common} />
        <path d="M149 104c29-34 153-34 182 0" {...common} opacity="0.45" />
      </svg>
    )
  }

  return (
    <svg viewBox="0 0 480 480" aria-hidden="true">
      <rect x="106" y="112" width="268" height="256" rx="36" {...common} />
      <circle cx="310" cy="176" r="28" {...common} />
      <path d="M155 296h170" {...common} opacity="0.45" />
      <path d="M155 323h98" {...common} opacity="0.45" />
      <path d="M203 112v-36h74v36" {...common} />
      <path d="M222 178l-28 54h42l-10 58 60-82h-41l16-30h-39Z" {...common} opacity="0.65" />
    </svg>
  )
}
